import React, { useContext } from 'react';
import { Button, ButtonType } from '@riotgames/accounts-react-components';
import cx from 'classnames';
import { Grid, GridAlignment, GridDirection, GridJustify } from '@riotgames/accounts-react-components/lib/Grid';
import { GridPanel } from '@riotgames/accounts-react-components/lib/Grid/GridPanel';
import AppContext from '../../AppContext';
import AccountsList from '../../comps/AccountsList';
import './checkAccount.scss';

const ExistingAccounts = ({ handleMoveNext }) => {
  const context = useContext(AppContext);
  const {
    actions: { setData },
    state: { existingAccounts, moreAccountsAllowed }
  } = context;

  const moveNext = () => {
    if (!moreAccountsAllowed) {
      setData({
        hasError: true,
        shouldReset: true,
        errorDetail: '가입계정이 5개를 초과하거나 회원가입제한이 적용되어 있을 경우 추가 회원가입이 제한됩니다.'
      });
      return false;
    }

    handleMoveNext();
  };

  if (existingAccounts.length === 0) {
    moveNext();
    return <></>;
  }

  const DormantButton = () =>
    existingAccounts.filter((acc) => acc.accountState === 'LOCKED' || acc.accountState === 'ARCHIVED').length > 0 && (
      <Button
        buttonType={ButtonType.secondary}
        label={'계정활성화'}
        onClick={() => window.open(process.env.REACT_APP_DORMANT_URL)}
      />
    );

  return (
    <GridPanel
      title={'라이엇 계정이 있습니다.'}
      subTitle={
        <p className="help-text">최대 5개까지 생성 가능하며, 새로 만들기를 누르시면 추가 회원가입이 가능합니다.</p>
      }
      button={
        <Button
          className="button-text-anchor"
          buttonType={ButtonType.secondary}
          label="새로 만들기"
          onClick={moveNext}
        />
      }
    >
      <Grid direction={GridDirection.vertical} align={GridAlignment.center} justify={GridJustify.spaceBetween}>
        <AccountsList metrics={existingAccounts} />
        <DormantButton />
      </Grid>
    </GridPanel>
  );
};

export default ExistingAccounts;
